// src/lib/metaMatching.ts
// Kontext für die Meta Conversions API (src/server/metaFunnelEvent.ts), der mit Funnel-Ereignissen
// an /api/session-status geht. Browser-Kennungen (_fbp/_fbc, User-Agent) NUR mit Marketing-
// Einwilligung im propora_consent-Cookie – ohne Einwilligung nur {mc:"0"}, dann sendet der Server
// nichts an Meta. Wird nicht in product_events gespeichert.
import { readConsentCookieFromDocument } from "@/lib/consent";
import type { MetaMatchingContext } from "@/server/metaFunnelEvent";
import { readLandingAttributionCache } from "@/hooks/useLandingAttributionCache";

function readCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function metaMatchingContext(): MetaMatchingContext {
  if (typeof window === "undefined") return { mc: "0" };
  if (readConsentCookieFromDocument()?.marketing !== true) return { mc: "0" };
  const ctx: MetaMatchingContext = { mc: "1", url: window.location.href };
  const fbp = readCookie("_fbp");
  if (fbp) ctx.fbp = fbp;
  const fbc = readCookie("_fbc");
  const fbclid = new URLSearchParams(window.location.search).get("fbclid") || readLandingAttributionCache()?.fbclid;
  if (fbc) ctx.fbc = fbc;
  else if (fbclid) ctx.fbc = `fb.1.${Date.now()}.${fbclid}`;
  if (navigator.userAgent) ctx.ua = navigator.userAgent.slice(0, 400);
  return ctx;
}
